var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 7.66667V9.33333M4.66675 7.66667V3.66667C4.66675 3.40145 4.7721 3.1471 4.95964 2.95956C5.14718 2.77202 5.40153 2.66667 5.66675 2.66667C5.93196 2.66667 6.18632 2.77202 6.37386 2.95956C6.56139 3.1471 6.66675 3.40145 6.66675 3.66667M4.66675 7.66667C4.66675 7.40145 4.56139 7.1471 4.37386 6.95956C4.18632 6.77202 3.93196 6.66667 3.66675 6.66667C3.40153 6.66667 3.14718 6.77202 2.95964 6.95956C2.7721 7.1471 2.66675 7.40145 2.66675 7.66667V9C2.66675 10.3261 3.19353 11.5979 4.13121 12.5355C5.0689 13.4732 6.34067 14 7.66675 14C8.99283 14 10.2646 13.4732 11.2023 12.5355C12.14 11.5979 12.6667 10.3261 12.6667 9V5.66667C12.6667 5.40145 12.5614 5.1471 12.3739 4.95956C12.1863 4.77202 11.932 4.66667 11.6667 4.66667C11.4015 4.66667 11.1472 4.77202 10.9596 4.95956C10.7721 5.1471 10.6667 5.40145 10.6667 5.66667M6.66675 3.66667V7.33333M6.66675 3.66667V3C6.66675 2.73478 6.7721 2.48043 6.95964 2.29289C7.14718 2.10536 7.40153 2 7.66675 2C7.93196 2 8.18632 2.10536 8.37386 2.29289C8.56139 2.48043 8.66675 2.73478 8.66675 3V3.66667M10.6667 5.66667V3.66667C10.6667 3.40145 10.5614 3.1471 10.3739 2.95956C10.1863 2.77202 9.93196 2.66667 9.66675 2.66667C9.40153 2.66667 9.14718 2.77202 8.95964 2.95956C8.7721 3.1471 8.66675 3.40145 8.66675 3.66667M10.6667 5.66667V7.33333M8.66675 3.66667V7.33333",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandOutline);
export default __webpack_public_path__ + "static/media/HandOutline.5098586c961359b2e69d6a611688d8f6.svg";
export { ForwardRef as ReactComponent };